import AudioControlsComponent from './audio-controls.component'

export default AudioControlsComponent
